import React from "react";
import { Outlet } from "react-router-dom";

import Header from "../layout/Header";
import Footer from "../layout/Footer";

/**
 * The marketing chrome. Header and Footer used to sit outside <Routes>, which
 * put the site nav around the admin screens too — those bring their own frame.
 */
export default function PublicLayout() {
  return (
    <>
      <Header />
      <Outlet />
      <Footer />
    </>
  );
}
